const NoDataFound = () => {
    return (
        <div className="bg-gray-100 flex flex-col justify-center items-center p-4 rounded-md">
            <div className="mt-4 text-sm">No Data Found</div>
        </div>
    )
}
export default NoDataFound